import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';
import Interstitial from '../Interstitial';
import { getPromoInterstitialState, getInterstitialMediaState } from '../store/interstitialSelector';

const InterstitialContainer = ({ onClose }) => {
    const { promoInterstitial, appPath, language } = useSelector(getPromoInterstitialState);
    const { banner, gamePk, type, descriptionKey, buttonKey, description, buttonText, slug, interstitialUrl } = promoInterstitial?.[0] || [];
    const interstitialMediaState = type === 'watch' ? useSelector(getInterstitialMediaState) : null;

    return (
        <ErrorBoundaryWrapper componentName='Interstitial'>
            <Interstitial
                appPath={appPath}
                banner={banner}
                gamePk={gamePk}
                language={language}
                type={type}
                descriptionKey={descriptionKey}
                buttonKey={buttonKey}
                buttonText={buttonText}
                description={description}
                interstitialUrl={interstitialUrl}
                slug={slug}
                onClose={onClose}
                {...interstitialMediaState}
            />
        </ErrorBoundaryWrapper>
    );
};

InterstitialContainer.propTypes = {
    onClose: PropTypes.func
};

export default InterstitialContainer;
